import React, { useState } from "react";
import styled from "styled-components";
import { InputBox } from "./Components/InputBox";
import Button from "../Generic/Button";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { errorNotification } from "../Generic/Notifications";

const Container = styled.div`
	font-family: "Actor", sans-serif;
	display: flex;
	justify-content: center; 
	align-items: center;
	height: 100%;
	width: 100%;
	transition: 0.5s all ease-in-out;
`;

const Box = styled.div`
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
	background: #fff;
	color: #000;
	height: max-content;
	padding: 2rem;
	width: 35rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 2rem;
	transition: 0.5s all ease-in-out;
	@media (max-width: 1160px) {
		width: 25rem;
	}
	@media (max-width: 500px) {
		width: 80%;
	}
`;

const Head = styled.div`
	font-size: 2.5rem;
	color: ;
	font-weight: 700;
	margin: 0rem 0 0 0;
`;

const Login = () => {
	const [email, setEmail] = useState(null);
	const [password, setPassword] = useState(null);
	const navigate = useNavigate();
	const location = useLocation();
	const { redirectTo } = location.state || {};
	const auth = getAuth();

	async function loginUser(email, password) {
		if (!email) {
			errorNotification("Invalid Email");
			return;
		} else if (!password) {
			errorNotification("Invalid Password");
			return;
		} 
		try {
			await signInWithEmailAndPassword(auth, email, password);
		} catch(error) {
			//TODO: Handle Firebase Errors.
			errorNotification(error.message);
			return;
		}
		navigate(redirectTo || "/");
	}

	return (
		<Container>
			<Box>
			{/*TODO:  Convert this into form for additional validation of email */}
				<Head>Login</Head>
				<InputBox
					onChange={(e) => setEmail(e.target.value)}
					autoComplete="off"
					id="username"
					width="80%"
					margin="2rem 1rem"
					placeholder="Username"
				/>
				<InputBox
					onChange={(e) => setPassword(e.target.value)}
					autoComplete="off"
					id="password"
					width="80%"
					placeholder="Password"
					type="password"
				/>
				<Button
					margin="3rem 0 0 0"
					onClick={() => {
						loginUser(email, password);
					}}>
					Login
				</Button>
			</Box>
		</Container>
	);
};

export default Login;
